"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaFielKeyTranslation = void 0;
exports.SchemaFielKeyTranslation = {
    // TODO rather use i18n after refacto
    comment: 'Commentaire',
    default: 'Texte libre',
    format: 'Format défini',
    is: 'Valeur imposée',
    labels: 'Labels',
    none: 'Vide',
    oneOf: 'Choix multiple (1 valeur)',
    someOf: 'Choix multiple (plusieurs valeurs)',
};
//# sourceMappingURL=schemaField.js.map